import React, { useState } from 'react';
import './SectionHelpButton.css';

const SectionHelpButton = ({ title, purpose, instructions }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="section-help-trigger"
        aria-label={`Help over ${title}`}
        onClick={() => setIsOpen(true)}
      >
        ?
      </button>

      {isOpen && (
        <div className="section-help-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="section-help-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={`Help: ${title}`}
          >
            <div className="section-help-header">
              <h3>{title} - Help</h3>
              <button
                type="button"
                className="section-help-close"
                aria-label="Sluiten"
                onClick={() => setIsOpen(false)}
              >
                &times;
              </button>
            </div>

            <div className="section-help-body">
              <p><strong>Doel:</strong> {purpose}</p>
              <div>
                <strong>Hoe te gebruiken:</strong>
                <ol>
                  {instructions.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SectionHelpButton;